export enum ProductStatusEnum {
  draft = 1,
  private = 2,
  publish = 3,
}
